import { useMemo } from 'react'

import { toISO8601 } from '@fortem-monorepo/js-utilities'
import { defaultGetRowId } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'

import { otherColDefs } from '@/pages/monitoring/_dashboard/columns'
import { useMonitoringContext } from '@/pages/monitoring/_dashboard/components/MonitoringContext'

interface TaskGroupTabProps {
  taskName: string
  date: Date
  /**
   * Either 1 for failed, or 2 for success
   */
  status: number
}

export const TaskGroupTab: React.FC<TaskGroupTabProps> = ({ taskName, date, status }) => {
  const { scheduledTasks } = useMonitoringContext()

  const tasks = useMemo(() => {
    return scheduledTasks.filter(
      (task) =>
        task.date === toISO8601(date) && task.description === taskName && task.status === status,
    )
  }, [scheduledTasks])

  return (
    <>
      <CustomAgGrid
        domLayout={'normal'}
        columnDefs={otherColDefs}
        rowData={tasks}
        getRowId={defaultGetRowId}
      />
    </>
  )
}
